var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgICircleError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2566_23138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 15.1998C4.03015 15.1998 0.800049 11.9697 0.800049 7.9998C0.800049 4.0299 4.03015 0.799805 8.00005 0.799805C11.9699 0.799805 15.2 4.0299 15.2 7.9998C15.2 11.9697 11.9699 15.1998 8.00005 15.1998ZM8.00005 1.6467C4.49635 1.6467 1.64695 4.4961 1.64695 7.9998C1.64695 11.5035 4.49635 14.3529 8.00005 14.3529C11.5037 14.3529 14.3531 11.5035 14.3531 7.9998C14.3531 4.4961 11.5037 1.6467 8.00005 1.6467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3735 9.74363C10.549 9.91913 10.549 10.2044 10.3726 10.3799C10.1971 10.5554 9.91177 10.5545 9.73627 10.379L5.62687 6.25523C5.45137 6.07883 5.45137 5.79443 5.62777 5.61803C5.80417 5.44343 6.08857 5.44343 6.26407 5.61983L10.3735 9.74363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62687 9.74374C5.45137 9.91924 5.45137 10.2045 5.62777 10.38C5.80327 10.5555 6.08857 10.5546 6.26407 10.3791L10.3726 6.25444C10.5481 6.07804 10.5481 5.79364 10.3717 5.61724C10.1953 5.44354 9.91177 5.44354 9.73627 5.61994L5.62687 9.74374Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2566_23138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICircleError);
export default __webpack_public_path__ + "static/media/i-circle-error.2fbf72b0132968f19cf94b269e533fb6.svg";
export { ForwardRef as ReactComponent };